import chmln from '@chamaeleonidae/chmln';
import { createSlice } from '@reduxjs/toolkit';
import { incApi } from 'api/inc-api';
import { getClientAlias } from 'util/client-alias';

const sliceName = 'user';

export const initialState = {
  access_token: null,
  refresh_token: null,
  account_id: null,
  client_id: null,
  userDetails: null,
};

const user = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    refreshToken: (state, { payload }) => {
      state.access_token = payload.access_token;
      state.refresh_token = payload.refresh_token;
    },
    setAccountIdAndClientId: (state, { payload }) => {
      state.account_id = payload.account_id;
      state.client_id = payload.client_id;
    },
    logout: state => {
      state.access_token = null;
      state.refresh_token = null;
      state.account_id = null;
      state.client_id = null;
      state.userDetails = null;
      window.heap?.resetIdentity?.();
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(
        incApi.endpoints.token.matchFulfilled,
        (state, { meta, payload }) => {
          state.access_token = payload.access_token;
          state.refresh_token = meta.arg.originalArgs.remember
            ? payload.refresh_token
            : null;
          state.account_id = payload.account_id;
          state.client_id = payload.client_id;
        },
      )
      .addMatcher(incApi.endpoints.logout.matchFulfilled, state => {
        state.access_token = null;
        state.refresh_token = null;
        state.account_id = null;
        state.client_id = null;
        state.userDetails = null;
        window.heap?.resetIdentity?.();
      })
      .addMatcher(incApi.endpoints.logout.matchRejected, state => {
        state.access_token = null;
        state.refresh_token = null;
        state.account_id = null;
        state.client_id = null;
        state.userDetails = null;
        window.heap?.resetIdentity?.();
      })
      .addMatcher(
        incApi.endpoints.getAdmin.matchFulfilled,
        (state, { payload }) => {
          if (payload.adminId === state.account_id) {
            state.userDetails = payload;
          }
        },
      )
      .addMatcher(
        incApi.endpoints.chmlnSignature.matchFulfilled,
        (state, { payload }) => {
          if (!!state.userDetails) {
            chmln.identify(state.userDetails.adminId, {
              uid_hash: payload.uidHash,
              email: state.userDetails.email,
              name: `${state.userDetails.firstName} ${state.userDetails.lastName}`,
              company: {
                uid: state.client_id,
                name: getClientAlias(),
              },
            });
            window.heap?.identify(state.userDetails.adminId);
            window.heap?.addUserProperties({
              email: state.userDetails.email,
              name: `${state.userDetails.firstName} ${state.userDetails.lastName}`,
              client: getClientAlias(),
              clientId: state.client_id,
            });
          }
        },
      );
  },
});

// ACTIONS
export const userActions = {
  ...user.actions,
};

export default user;
